import Jobs from "../../components/customer/jobs/jobs";

const JobsPage = () => {
  return <Jobs />;
};

export default JobsPage;

